import styled from "styled-components";

export const IconWrap = styled.div`
  position: relative;
  margin: 0 auto;
  width: 172px;
  height: 172px;
  border-radius: 50%;
  background-image: linear-gradient(to bottom, #ffffff, #fdfdfb);
  margin-bottom: 15px;
  &::after {
    content: "";
    position: absolute;
    background-color: white;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 130px;
    border-radius: 50%;
    height: 130px;
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
  }
  img {
    z-index: 3;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    height: 75px;
  }
`;

export const ItemWrap = styled.li`
  text-align: center;
  position: relative;
  z-index: 35;
  color: var(--color-primary);
  font-weight: 600;
  width: 300px;
  min-width: 300px;
  font-size: 16px;
  margin: 15px;
`;
